import { IUserCredential } from 'src/context/global/types';

export enum EEvents {
  ROTATE_NODES = 'rotateNodes',
  RELOAD_VALIDATE = 'reloadValidate',
  /** Fired when node data is updated; listener should run validateNode and update node.data.category.isValid + validationErrors */
  NODES_CHANGED = 'nodesChanged',
  REPLACE_USER_CREDENTIALS = 'replaceUserCredentials',
}

export type RotateNodesEvent = {
  nodeIds: string[];
};

export type ReloadValidateEvent = {
  nodeIds: string[];
};

export type NodesChangedEvent = {
  nodeIds: string[];
};

export type ReplaceUserCredentialsEvent = {
  userCredentials: IUserCredential[];
};
